function PaginationService($translate) {
    'ngInject';

    return {
        initialise(options) {
            if (!options) {
                return;
            }
            const paginator = {
                current_page: 1,
                page_size: options.page_size,
                num_pages: null,
                max_size: options.max_size,
                num_items: null
            };
            return paginator;
        },


        update(paginator, length) {
            if (!paginator || (length == null)) {
                return;
            }
            paginator.num_items = length;
            const start = ((paginator.page_size - 1) * paginator.current_page) - ((paginator.page_size - 1) - paginator.current_page);
            let end = paginator.current_page * paginator.page_size;
            const total = end < paginator.page_size ? end : length;
            end = end > total ? total : end;
            return paginator.summary = $translate.instant('CORE.PAGINATION.SUMMARY', {start, end, total});
        },

        checkItems(paginator, items_loaded) {

            // determine if we need to load more items from the API

            const items_traversed = paginator.page_size * (paginator.current_page - 1);
            const remaining_items = paginator.num_items - items_loaded;

            return (items_loaded < (items_traversed + paginator.page_size)) && (remaining_items > 0);
        }
    };
}

angular
    .module('BB')
    .service('PaginationService', PaginationService);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/paginiation.service.js